/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeRegistrationDataViewModel } from '../../models/employee-registration-data-view-model';

export interface GetActiveEmployeeRegistrationData$Params {
  workCenterId: number;
}

export function getActiveEmployeeRegistrationData(http: HttpClient, rootUrl: string, params: GetActiveEmployeeRegistrationData$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeRegistrationDataViewModel>> {
  const rb = new RequestBuilder(rootUrl, getActiveEmployeeRegistrationData.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeRegistrationDataViewModel>;
    })
  );
}

getActiveEmployeeRegistrationData.PATH = '/api/v1/{workCenterId}/GetActiveEmployeeRegistrationData';
